import React from "react";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { handleVerificationSelection } from "./ClipsUtilities/handleVerificationSelection";

export const VerifiedButton = ({
  verifiedClicked,
  setVerifiedClicked,
  setUnverifiedClicked,
  selectedRow,
  clipsData,
  setClipsData,
  setSelectedRow,
  setPageLoading,
  navigate,
}: {
  verifiedClicked: boolean;
  setVerifiedClicked: Dispatcher<boolean>;
  setUnverifiedClicked: Dispatcher<boolean>;
  selectedRow: any;
  clipsData: any;
  setClipsData: any;
  setSelectedRow: any;
  setPageLoading: any;
  navigate: NavigateFunction;
}) => {
  const filledButton = (
    <button
      className="shadow-button bg-[#2E7D32] border-2	border-[#2E7D32] rounded font-mulish text-white text-base p-1.5 w-[170px]"
      onClick={() => {
        setVerifiedClicked(true);
        setUnverifiedClicked(false);
        handleVerificationSelection(
          "Verified",
          selectedRow,
          clipsData,
          setClipsData,
          setSelectedRow,
          setPageLoading,
          setVerifiedClicked,
          setUnverifiedClicked,
          navigate
        );
      }}
      disabled={false}
    >
      Verified
    </button>
  );

  const unfilledButton = (
    <button
      className="shadow-button bg-white border-2	border-[#2E7D32] rounded font-mulish text-[#2E7D32] text-base p-1.5 w-[170px]"
      onClick={() => {
        setVerifiedClicked(true);
        setUnverifiedClicked(false);
        handleVerificationSelection(
          "Verified",
          selectedRow,
          clipsData,
          setClipsData,
          setSelectedRow,
          setPageLoading,
          setVerifiedClicked,
          setUnverifiedClicked,
          navigate
        );
      }}
      disabled={false}
    >
      Verified
    </button>
  );

  return verifiedClicked ? filledButton : unfilledButton;
};
